import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { first, tap } from "rxjs/operators";

import { GrowlService } from "@lantern/app/core";

import { GlobalAuthService } from "@local/app/core/global-auth";

@Injectable()
export class RequireLoggedInGuard implements CanActivate {
  constructor(
    private globalAuth: GlobalAuthService,
    private router: Router,
    private growlService: GrowlService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.globalAuth.isLoggedIn.pipe(
      first(),
      tap((isLoggedIn) => {
        const fromMart = route.queryParamMap.get("from-mart");
        if (fromMart) {
          this.growlService.open.call(this.growlService, {
            type: "danger",
            message: `You don't have access to ${fromMart}. If you believe that this is not intended please contact an administrator`,
            duration: 6000
          });
          this.router.navigateByUrl("");
        }
        if (!isLoggedIn) {
          const redirect =
            route.routeConfig?.path != null
              ? `?redirect=${encodeURIComponent(
                  `${window.location.origin}/#/${route.routeConfig.path}`
                )}`
              : "";

          this.router.navigateByUrl(`/login${redirect}`);
        }
      })
    );
  }
}
